import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgOdnoklassniki = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 16.186C0 8.644 0 4.872 2.343 2.529S8.458.186 16 .186c7.543 0 11.314 0 13.657 2.343S32 8.644 32 16.186c0 7.543 0 11.314-2.343 13.657S23.543 32.186 16 32.186c-7.542 0-11.314 0-13.657-2.343S0 23.729 0 16.186Z"
      fill="url(#Odnoklassniki_svg__a)"
    />
    <path
      d="M16 6.592c-2.67 0-4.844 2.178-4.844 4.856S13.33 16.304 16 16.304c2.672 0 4.844-2.178 4.844-4.856S18.672 6.592 16 6.592Zm0 2.845a2.01 2.01 0 0 1 0 4.021 2.01 2.01 0 0 1 0-4.02Zm-3.993 7.032a1.426 1.426 0 0 0-.78 2.628 9.075 9.075 0 0 0 2.812 1.168l-2.707 2.715a1.426 1.426 0 0 0 0 2.012 1.415 1.415 0 0 0 2.008 0L16 22.324l2.661 2.668a1.416 1.416 0 0 0 2.007 0 1.425 1.425 0 0 0 0-2.012l-2.709-2.715a9.062 9.062 0 0 0 2.813-1.168 1.425 1.425 0 0 0 .446-1.962 1.417 1.417 0 0 0-1.958-.447 6.137 6.137 0 0 1-6.521 0 1.41 1.41 0 0 0-.732-.22Z"
      fill="#fff"
    />
    <defs>
      <linearGradient
        id="Odnoklassniki_svg__a"
        x1={16}
        y1={0.186}
        x2={16}
        y2={32.186}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFA022" />
        <stop offset={1} stopColor="#FF831D" />
      </linearGradient>
    </defs>
  </svg>
);
const Memo = memo(SvgOdnoklassniki);
export default Memo;
